<template>
  <section class="mailbox-inner-wrapper reduce-header">
    <div class="mailbox-inner-container">

      <!-- This section lists the unread email folders -->
      <div v-if="this.$route.params.type == 'unread'">
        <ul
          class="mailbox-inner-content"
          v-if="unreadEmails.length > 0"
        >
          <transition-group name="swipe" mode="out-in" appear>
            <li class="edit-mode" v-for="ib in unreadEmails" :key="ib.mailBoxId" @click="viewMailDetail(ib.mailBoxId, 'inbox')">
              <label class="container-checkbox" v-if="isEditCicked" @click="event => event.stopPropagation()">
                <span class="checkmark"
                  :class="{checked: selectedMailboxIDs.includes(ib.mailBoxId)}"
                ></span>
                <input type="checkbox" v-if="isEditCicked" v-model="selectedMailboxIDs" :value="ib.mailBoxId">
              </label>
              <div class="email-quick-view">
                <div class="sender-info">

                  <span class="blue-dot" v-if="0 === ib.readStatus" ></span>

                  <div class="email-subject"
                       v-if="stripTags(ib.sub.substring(0, 100)).trim()">
                    {{ stripTags(ib.sub.substring(0, 100)) }}
                  </div>
                  <div class="no-subject" v-else>...</div>
                  <div class="email-sent-time">{{ ib.time }}</div>
                  <!--<div class="loader-container-small"
                       @click="event => event.stopPropagation()"
                       v-if="ib.isFavourite === 'serverReq'">
                     <div class="loader-small"></div>
                  </div>
                  <span class="icon-star" @click="event => event.stopPropagation()" v-else>

                    &lt;!&ndash; Empty star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="emptyStarIcon"
                      v-if="ib.isFavourite === '0'"
                      @click="sendAddFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />

                    &lt;!&ndash; Filled star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="filledStarIcon"
                      v-else
                      @click="sendRemoveFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />
                  </span>-->
                </div>
                <div class="email-sender-name">{{ ib.from }}</div>
                <div class="email-excerpt" v-html="stripTags(ib.message).substring(0, 200)"></div>
              </div>
            </li>
          </transition-group>
        </ul>
        <ul class="mailbox-inner-content" v-else-if="0 === unreadEmails.length && !emaillist.unread.loading">
          <li>
            <div class="mailbox-content block-center">
              <div class="title no-ue">
                <span class="name">You have no unread email</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="loader-container-top" v-if="emaillist.unread.loading">
          <mail-loader-vue/>
        </div>
      </div>

      <!-- This section lists the emails of inbox folder. -->
      <div v-if="this.$route.params.type == 'inbox'">
        <ul class="mailbox-inner-content" v-if="inbox.length > 0">
          <transition-group name="swipe" mode="out-in" appear>
            <li v-for="ib in inbox" :key="ib.mailBoxId" @click="viewMailDetail(ib.mailBoxId, 'inbox')">
              <label class="container-checkbox" v-if="isEditCicked" @click="event => event.stopPropagation()">
                <span class="checkmark"
                  :class="{checked: selectedMailboxIDs.includes(ib.mailBoxId)}"
                ></span>
                <input type="checkbox" v-if="isEditCicked" v-model="selectedMailboxIDs" :value="ib.mailBoxId">
              </label>
              <div class="email-quick-view">
                <div class="sender-info">
                  <span class="blue-dot" v-if="0 === ib.readStatus" ></span>

                  <div class="email-subject" v-if="stripTags(ib.sub.substring(0, 100)).trim()">
                    {{ stripTags(ib.sub.substring(0, 100)) }}
                  </div>
                  <div class="no-subject" v-else>...</div>
                  <div class="email-sent-time">{{ ib.time }}</div>
                  <!--<div class="loader-container-small"
                       @click="event => event.stopPropagation()"
                       v-if="ib.isFavourite === 'serverReq'">
                    <div class="loader-small"></div>
                  </div>
                  <span class="icon-star" @click="event => event.stopPropagation()" v-else>
                    &lt;!&ndash; Empty star &ndash;&gt;
                    <img
                    class="img-star"
                    :src="emptyStarIcon"
                    v-if="ib.isFavourite === '0'"
                    @click="sendAddFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />

                    &lt;!&ndash; Filled star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="filledStarIcon"
                      v-else
                      @click="sendRemoveFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />
                  </span>-->
                </div>
                <div class="email-sender-name">{{ ib.from }}</div>
                <div class="email-excerpt" v-html="stripTags(ib.message).substring(0, 200)"></div>
              </div>
            </li>
          </transition-group>
        </ul>
        <ul class="mailbox-inner-content" v-else-if="0 === inbox.length && !emaillist.inbox.loading">
          <li>
            <div class="mailbox-content block-center">
              <div class="title no-ue">
                <span class="name">You have no email</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="loader-container-top" v-if="emaillist.inbox.loading">
          <mail-loader-vue/>
        </div>
      </div>

      <!-- This section lists the emails of sent folder. -->
      <div v-if="this.$route.params.type == 'sent'">
        <ul class="mailbox-inner-content" v-if="sent.length > 0">
          <transition-group name="swipe" mode="out-in" appear>
            <li v-for="ib in sent" :key="ib.mailBoxId" @click="viewMailDetail(ib.mailBoxId, 'sent')">
              <label class="container-checkbox" v-if="isEditCicked" @click="event => event.stopPropagation()">
                <span class="checkmark"
                      :class="{checked: selectedMailboxIDs.includes(ib.mailBoxId)}"
                ></span>
                <input type="checkbox" v-if="isEditCicked" v-model="selectedMailboxIDs" :value="ib.mailBoxId">
              </label>
              <div class="email-quick-view">
                <div class="sender-info">
                  <span class="blue-dot" v-if="0 === ib.readStatus" ></span>

                  <div class="email-subject" v-if="stripTags(ib.sub.substring(0, 100))">
                    {{ stripTags(ib.sub.substring(0, 100)) }}
                  </div>
                  <div class="no-subject" v-else>...</div>
                  <div class="email-sent-time">{{ ib.time }}</div>
                  <!--<div class="loader-container-small"
                       @click="event => event.stopPropagation()"
                       v-if="ib.isFavourite === 'serverReq'">
                    <div class="loader-small"></div>
                  </div>
                  <span class="icon-star" @click="event => event.stopPropagation()" v-else>
                    &lt;!&ndash; Empty star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="emptyStarIcon"
                      v-if="ib.isFavourite === '0'"
                      @click="sendAddFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />

                    &lt;!&ndash; Filled star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="filledStarIcon"
                      v-else
                      @click="sendRemoveFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />
                  </span>-->
                </div>
                <div class="email-sender-name">{{ ib.to }}</div>
                <div class="email-excerpt" v-html="stripTags(ib.message).substring(0, 200)"></div>
              </div>
            </li>
          </transition-group>
        </ul>
        <ul class="mailbox-inner-content" v-else-if="0 === sent.length && !emaillist.sent.loading">
          <li>
            <div class="mailbox-content block-center">
              <div class="title no-ue">
                <span class="name">You have no sent email</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="loader-container-top" v-if="emaillist.sent.loading">
          <mail-loader-vue/>
        </div>
      </div>

      <!-- This section lists the email of draft folder. -->
      <div v-if="this.$route.params.type == 'draft'">
        <ul class="mailbox-inner-content" v-if="drafts.length > 0">
          <transition-group name="swipe" mode="out-in" appear>
            <li v-for="ib in drafts" :key="ib.mailBoxId" @click="viewMailDetail(ib.mailBoxId, 'draft')">
              <label class="container-checkbox" v-if="isEditCicked" @click="event => event.stopPropagation()">
                <span class="checkmark"
                      :class="{checked: selectedMailboxIDs.includes(ib.mailBoxId)}"
                ></span>
                <input type="checkbox" v-if="isEditCicked" v-model="selectedMailboxIDs" :value="ib.mailBoxId">
              </label>
              <div class="email-quick-view">
                <div class="sender-info">
                  <span class="blue-dot" v-if="0 === ib.readStatus" ></span>

                  <div class="email-subject" v-if="stripTags(ib.sub.substring(0, 100)).trim()">
                    {{ stripTags(ib.sub.substring(0, 100)) }}
                  </div>
                  <div class="no-subject" v-else>...</div>
                  <div class="email-sent-time">{{ ib.time }}</div>
                  <!--<div class="loader-container-small"
                       @click="event => event.stopPropagation()"
                       v-if="ib.isFavourite === 'serverReq'">
                    <div class="loader-small"></div>
                  </div>
                  <span class="icon-star" @click="event => event.stopPropagation()" v-else>
                    &lt;!&ndash; Empty star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="emptyStarIcon"
                      v-if="ib.isFavourite === '0'"
                      @click="sendAddFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />

                    &lt;!&ndash; Filled star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="filledStarIcon"
                      v-else
                      @click="sendRemoveFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />
                  </span>-->
                </div>
                <div class="email-sender-name">{{ ib.draftTo.trim() ? ib.draftTo : ib.from }}</div>
                <div class="email-excerpt" v-html="stripTags(ib.message).substring(0, 200)"></div>
              </div>
            </li>
          </transition-group>
        </ul>
        <ul class="mailbox-inner-content" v-else-if="0 === drafts.length && !emaillist.draft.loading">
          <li>
            <div class="mailbox-content block-center">
              <div class="title no-ue">
                <span class="name">You have no draft email</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="loader-container-top" v-if="emaillist.draft.loading">
          <mail-loader-vue/>
        </div>
      </div>

      <!-- This section lists the trash folder emails. -->
      <div v-if="this.$route.params.type == 'trash'">
        <ul class="mailbox-inner-content" v-if="trash.length > 0">
          <transition-group name="swipe" mode="out-in" appear>
            <li v-for="ib in trash" :key="ib.mailBoxId" @click="viewMailDetail(ib.mailBoxId, 'trash')">
              <label class="container-checkbox" v-if="isEditCicked" @click="event => event.stopPropagation()">
                <span class="checkmark"
                      :class="{checked: selectedMailboxIDs.includes(ib.mailBoxId)}"
                ></span>
                <input type="checkbox" v-if="isEditCicked" v-model="selectedMailboxIDs" :value="ib.mailBoxId">
              </label>
              <div class="email-quick-view">
                <div class="sender-info">
                  <span class="blue-dot" v-if="0 === ib.readStatus" ></span>

                  <div class="email-subject" v-if="stripTags(ib.sub.substring(0, 100)).trim()">
                    {{ stripTags(ib.sub.substring(0, 100)) }}
                  </div>
                  <div class="no-subject" v-else>...</div>
                  <div class="email-sent-time">{{ ib.time }}</div>
                  <!--<div class="loader-container-small"
                       @click="event => event.stopPropagation()"
                       v-if="ib.isFavourite === 'serverReq'">
                    <div class="loader-small"></div>
                  </div>
                  <span class="icon-star" @click="event => event.stopPropagation()" v-else>
                    &lt;!&ndash; Empty star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="emptyStarIcon"
                      v-if="ib.isFavourite === '0'"
                      @click="sendAddFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />

                    &lt;!&ndash; Filled star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="filledStarIcon"
                      v-else
                      @click="sendRemoveFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />
                  </span>-->
                </div>
                <div class="email-sender-name">
                  {{ "Draft" === ib.boxType ? (ib.to.trim() ? ib.to: ib.from) : ("Sent" === ib.boxType ? ib.to : ib.from) }}</div>
                <div class="email-excerpt" v-html="stripTags(ib.message).substring(0, 200)"></div>
              </div>
            </li>
          </transition-group>
        </ul>
        <ul class="mailbox-inner-content" v-else-if="0 === trash.length && !emaillist.trash.loading">
          <li>
            <div class="mailbox-content block-center">
              <div class="title no-ue">
                <span class="name">You have no trash email</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="loader-container-top" v-if="emaillist.trash.loading">
          <mail-loader-vue/>
        </div>
      </div>

      <!-- This section lists the personalised folder emails. -->
      <div v-if="this.$route.params.type == 'custom'">
        <ul class="mailbox-inner-content" v-if="folderEmails.length > 0">
          <transition-group name="swipe" mode="out-in" appear>
            <li v-for="ib in folderEmails" :key="ib.mailBoxId" @click="viewMailDetail(ib.mailBoxId, 'inbox')">
              <label class="container-checkbox" v-if="isEditCicked" @click="event => event.stopPropagation()">
                <span class="checkmark"
                  :class="{checked: selectedMailboxIDs.includes(ib.mailBoxId)}"
                ></span>
                <input type="checkbox" v-if="isEditCicked" v-model="selectedMailboxIDs" :value="ib.mailBoxId">
              </label>
              <div class="email-quick-view">
                <div class="sender-info">
                  <span class="blue-dot" v-if="0 === ib.readStatus" ></span>

                  <div class="email-subject" v-if="stripTags(ib.sub.substring(0, 100)).trim()">
                    {{ stripTags(ib.sub.substring(0, 100)) }}
                  </div>
                  <div class="no-subject" v-else>...</div>
                  <div class="email-sent-time">{{ ib.time }}</div>
                  <!--<div class="loader-container-small"
                       @click="event => event.stopPropagation()"
                       v-if="ib.isFavourite === 'serverReq'">
                    <div class="loader-small"></div>
                  </div>
                  <span class="icon-star" @click="event => event.stopPropagation()" v-else>
                    &lt;!&ndash; Empty star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="emptyStarIcon"
                      v-if="ib.isFavourite === '0'"
                      @click="sendAddFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />

                    &lt;!&ndash; Filled star &ndash;&gt;
                    <img
                      class="img-star"
                      :src="filledStarIcon"
                      v-else
                      @click="sendRemoveFavouritesRequest(ib.mailBoxId, ib.folderId)"
                    />
                  </span>-->
                </div>
                <div class="email-sender-name">{{ ib.from }}</div>
                <div class="email-excerpt" v-html="stripTags(ib.message).substring(0, 200)"></div>
              </div>
            </li>
          </transition-group>
        </ul>
        <ul class="mailbox-inner-content" v-else-if="0 === folderEmails.length && !isFolderEmailLoading">
          <li>
            <div class="mailbox-content block-center">
              <div class="title no-ue">
                <span class="name">You have no email</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="loader-container-top" v-if="isFolderEmailLoading">
          <mail-loader-vue/>
        </div>
      </div>
    </div>
    <move-email-vue v-if="selectedMailboxIDs.length > 0 && moveClicked"/>
  </section>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { nameMixin } from "../../../mixins/nameMixin";
import MoveEmailVue from "./MoveEmail.vue";
import Vue from "vue";
import MailLoaderVue from './MailLoader';

export default {
  name: "EmailDashboardSection",
  mixins: [nameMixin],
  props: {
    isEditCicked: Boolean,
    selectAll: Boolean,
    moveClicked: Boolean,
    moveToTrash: Boolean
  },
  components: {
    MoveEmailVue,
    MailLoaderVue
  },
  data() {
    return {
      emptyStarIcon: require("../../../assets/img/m_favorites-empty.png"),
      filledStarIcon: require("../../../assets/img/m_favorites.png"),
      selectedMailboxIDs: []
    };
  },
  computed: {
    ...mapGetters("portalemail", {
      emaillist: "getEmails",
      selectedUserId: "getSelectedUserId"
    }),

    /**
     * Computed props to return un-read emails.
     */
    unreadEmails() {
      return this.emaillist.unread.list;
    },

    /**
     * Computed props to return personalised folder emails.
     */
    folderEmails() {
      let folderId = this.$route.params.folderId;
      if(!folderId || !this.emaillist.custom[folderId]) {
        return [];
      }

      return this.emaillist.custom[folderId].list;
    },

    /**
     * Computed props to return inbox emails.
     */
    inbox() {
      return this.emaillist.inbox.list;
    },

    /**
     * Computed props to return trash emails.
     */
    trash() {
      return this.emaillist.trash.list;
    },

    /**
     * Computed props to return draft emails.
     */
    drafts() {
      return this.emaillist.draft.list;
    },

    /**
     * Computed props to return sent emails.
     */
    sent() {
      return this.emaillist.sent.list;
    },

    /**
     * Computed props to determine if a folder email is being loaded
     */
    isFolderEmailLoading() {
      return this.emaillist.custom[this.$route.params.folderId] ?
        this.emaillist.custom[this.$route.params.folderId].loading : false
    }
  },
  watch: {

    /**
     * Watcher to check if trash is clicked
     */
    moveToTrash(value) {
      if(value) {
        this.moveToTrashRequest();
      }
    },

    /**
     * Watcher to check if select all is clicked
     */
    selectAll(value) {
      if(value) {
        switch (this.$route.params.type) {
          case 'unread':
              this.unreadEmails.forEach(el => {
                this.selectedMailboxIDs.push(el.mailBoxId)
              });
            break;

          case 'inbox':
              this.inbox.forEach(el => {
                this.selectedMailboxIDs.push(el.mailBoxId)
              });
            break;

          case 'sent':
              this.sent.forEach(el => {
                this.selectedMailboxIDs.push(el.mailBoxId)
              });
            break;

          case 'draft':
              this.drafts.forEach(el => {
                this.selectedMailboxIDs.push(el.mailBoxId)
              });
            break;

          case 'trash':
              this.trash.forEach(el => {
                this.selectedMailboxIDs.push(el.mailBoxId)
              });
            break;

          case 'custom':
              this.folderEmails.forEach(el => {
                this.selectedMailboxIDs.push(el.mailBoxId)
              });
            break;

          default:
            break;
        }
      } else {
        this.selectedMailboxIDs = [];
      }
    }
  },
  methods: {

    ...mapMutations("portalemail", {
      setComposeEmailLoading: "setComposeEmailLoading",
      addRemoveFavourite: "addRemoveFavourite",
      resetEmails: "resetEmails",
      setBoxCount: "setBoxCount"
    }),

    /**
     * Function run on clicking a single mail, which will redirect to mail details page
     */
    viewMailDetail(mailboxId, type) {
      return this.$router.push(`/emails/${type}/${mailboxId}`);
    },

    /**
     * Function to send add favourite request
     */
    async sendAddFavouritesRequest(mailbox_id, folderId) {
      this.addRemoveFavourite({
        mailId: mailbox_id,
        boxType: this.$route.params.type,
        folderId: folderId ? folderId : 0,
        isAdd: 'serverReq'
      });

      let addFavouriteRes = await this.$store.dispatch(
        "makeAuthRequest",
        {
          url: "portalemail/addFavourite",
          method: "POST",
          chat: true,
          data: {
            mailbox_id: mailbox_id,
            selectedSubscriberId: this.$store.getters.getSelectedProviderID,
            appUserId: this.selectedUserId
          }
        },
        {
          root: true
        }
      );

      if(addFavouriteRes.error) {
        this.$store.dispatch("globalMessagePopup", addFavouriteRes.error);
      }

      this.addRemoveFavourite({
        mailId: mailbox_id,
        boxType: this.$route.params.type,
        folderId: folderId ? folderId : 0,
        isAdd: true
      });
    },

    /**
     * Function to send remove favourite request
     */
    async sendRemoveFavouritesRequest(mailbox_id, folderId) {
      this.addRemoveFavourite({
        mailId: mailbox_id,
        boxType: this.$route.params.type,
        folderId: folderId ? folderId : 0,
        isAdd: 'serverReq'
      });

      let removeFavouriteRes = await this.$store.dispatch(
        "makeAuthRequest",
        {
          url: "portalemail/removeFavourite",
          method: "POST",
          chat: true,
          data: {
            mailbox_id: mailbox_id,
            selectedSubscriberId: this.$store.getters.getSelectedProviderID,
            appUserId: this.selectedUserId
          }
        },
        {
          root: true
        }
      );

      if(removeFavouriteRes.error) {
        this.$store.dispatch("globalMessagePopup", removeFavouriteRes.error);
      }

      this.addRemoveFavourite({
        mailId: mailbox_id,
        boxType: this.$route.params.type,
        folderId: folderId ? folderId : 0,
        isAdd: false
      });
    },

    /**
     * Function to move emails to trash folder.
     */
    async moveToTrashRequest() {

      let boxType = -1;
      if((["inbox", "unread", "custom"]).includes(this.$route.params.type)) {
        boxType = 1;
      } else if(this.$route.params.type === "sent") {
        boxType = 2;
      } else if(this.$route.params.type === "draft") {
        boxType = 0;
      } else if(this.$route.params.type === "trash") {
        boxType = 3;
      }

      this.setComposeEmailLoading(true);
      let moveToTrashRes = await this.$store.dispatch(
        "makeAuthRequest",
        {
          url: "portalemail/movetotrash",
          method: "PUT",
          chat: true,
          data: {
            selectedMails: this.selectedMailboxIDs,
            boxType: boxType,
            selectedSubscriberId: this.$store.getters.getSelectedProviderID,
            appUserId: this.selectedUserId
          }
        },
        {
          root: true
        }
      );
      this.resetEmails({boxType: 'all', folderId: 0});
      await this.$parent.fetchMailList();
      this.setBoxCount({
        key: 'needLoad',
        value: true
      });
      await this.$parent.fetchInboxUnreadCount(false);
      this.setComposeEmailLoading(false);

      if(moveToTrashRes.error) {
        this.$store.dispatch("globalMessagePopup", moveToTrashRes.error);
      }

      Vue.nextTick(() => {
        this.$parent.clearEditState();
        this.$parent.moveClicked = false;
        this.$parent.moveToTrash = false;
      });
    },

    /**
     * Go to a specific chat
     */
    goToChat(fullID) {
      const [userOrGroup, id] = fullID.split(":");
      if (userOrGroup === "group") {
        return this.$router.push(`/messenger/group/${id}`);
      }
      return this.$router.push(`/messenger/${id}`);
    },

    escape(s) {
      // eslint-disable-next-line no-useless-escape
      return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    },

    stripTags(html) {
      var div = document.createElement("div");
      div.innerHTML = html;
      return div.innerText;
    }
  }
};
</script>

<style scoped>
.loader-container-top {
  display: flex;
  width: 100%;
  justify-content: center;
  position: relative;
  top: 15px;
}

.mailbox-inner-wrapper.reduce-header{
  margin:145px 0 !important;
}

.mailbox-inner-content label{
  display:inline-block;
  position:relative;
  top:5px;
}
.mailbox-inner-content label.container-checkbox {
  padding-left:25px;
  position:relative;
  top:0;
}
.mailbox-inner-content li.edit-mode, .mailbox-inner-content li{
  width:calc(100% - 30px)!important;
}
.mailbox-inner-content li label.container-checkbox{
  padding-left:25px;
  position: relative;
  top:0;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.mailbox-inner-content label.container-checkbox .checkmark {
    height: 18px;
    width: 18px;
    border-radius:3px;
    position: absolute;
    left:0;
    top:0;
    border:1px solid #5888c5!important;
  }

 .mailbox-inner-content label.container-checkbox .checked::after {
  content: "";
  background:#5888c5 url('../../../assets/img/icon-checked.png')!important;
  width: 18px;
  height: 18px;
    position: absolute;
    left:0;
    top:0;
 }

.mailbox-inner-content label.container-checkbox input {
    left:-3px;
    top:-2px;
      position: absolute;
      width:18px;
      height:18px;
      border:none!important;
      opacity:0;
}
section ul {
  display: flex;
  flex-direction: column;
  padding: 0;
  margin-top: 0px;
}

.reduce-header {
  margin-top: 93px !important;
}

section ul li {
  list-style: none;
  padding: 15px;
  display: flex;
  justify-content: start;
  align-items: flex-start;
  border-bottom:1px solid #f2f2f2;
}

.img-star {
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 1rem;
}

section ul li.online {
  border-right: 5px solid lightgreen;
}

section ul li:hover {
  /* background-color: rgba(210, 109, 19, 0.1); */
  cursor: pointer;
}

section ul li div.mailbox-content.no-star {
  max-width: 100%;
}

section ul li div.mailbox-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  max-width: 90%;
}

section ul li div.mailbox-content div.title {
  display: flex;
  margin-bottom: 3px;
}

section ul li div.mailbox-content div.content {
  display: flex;
}

section ul li div.mailbox-content div.content span.message {
  color: gray;
  font-size: 13px;
  flex-grow: 1;
  max-width: calc(100% - 20px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 18px;
}

section ul li div.mailbox-content div.content span.new-messages {
  font-size: 10px;
  background-color: rgb(210, 109, 19);
  width: 20px;
  height: 20px;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
}

section ul li div.mailbox-content div.title span.name {
  flex-grow: 1;
  font-weight: lighter;
  color: #383838;
}

section ul li div.mailbox-content div.title span.time {
  font-size: 13px;
  font-weight: lighter;
  color: gray;
}

.swipe-enter-active {
  animation: swipeIn 0.4s ease-in-out;
}

.swipe-leave-active {
  animation: swipeOut 0.4s ease-in-out;
}

.swipe-move {
  transition: all 0.4s ease-in-out;
}

.loader-container-small {
  padding: 1px 7px 0px 0px;
  position: absolute;
  right:-15px;
}

.loader-small {
  float: left;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #d26d13;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  animation: spin 0.5s linear infinite;
  margin-right: 10px;
}
.block-center{
  margin:0 auto;
}
.no-ue{
  text-align: center;
}
.email-quick-view{
  margin:0;
  width:100%;
  position: relative;
}
.blue-dot{
  width:8px;
  height:8px;
  border-radius: 100%;
  background:#5888c5;
  display:inline-block;
  position: relative;
  float:left;
  margin-right: 8px;
  top:3px;
}
.sender-info{
  margin:0 0 20px 0;
  font-weight: bold;
  position:relative;

}
.icon-star{
  position:absolute;
  right:0;
}
.icon-star img.img-star{
  width:21px!important;
  height:21px!important;
  margin-right: 0!important;
}
.email-sender-name{
  float:none;
  clear:both;
  margin:5px 0 8px 0;
  font-size:13px;
  color:#666;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.email-sent-time{
  float:right;
  color:#000;
  font-size:12px;
  font-weight: bold;
}
.email-subject, .no-subject{
  font-size:16px;
  font-weight: bold;
  margin:0 0 5px 0;
  line-height:22px;
  color:#d26d13;
  float:left;
}
.email-excerpt{
  font-size:13px;
  color:#000;
  height:auto;
  margin:0 0 5px 0px;
  line-height:24px;
}
@media screen and (max-width:420px){
  .email-subject, .no-subject{
    max-width:190px;
    word-break: break-all;
}
.email-excerpt{
  max-width:96%;
  overflow:hidden;
}

}
@keyframes swipeIn {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }

  50% {
    opacity: 0.5;
    transform: translateX(-50px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes swipeOut {
  from {
    opacity: 1;
    transform: translateX(0);
  }

  50% {
    opacity: 0.5;
    transform: translateX(-50px);
  }

  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
</style>
